import { render } from "./AboutCertificate.vue?vue&type=template&id=2c288fd0"
import script from "./AboutCertificate.vue?vue&type=script&lang=js"
export * from "./AboutCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__